import classNames from 'classnames';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import type { UserFreeSpinsData } from '../../stores/user-free-spins/types';
import { useStores } from '../../stores/useStores';
import { FRBWidget } from '../FRBWidget/FRBWidget';

import classes from './FreeSpinDialog.module.scss';

export const UserFreeSpinsWidget = observer(({ freeSpinData }: { freeSpinData: UserFreeSpinsData }) => {
  const { userFreeSpinsStore } = useStores();
  const { t } = useTranslation();
  const isBaroulettaGaming = ['Barouletta Gaming', 'Minigames'].includes(freeSpinData.provider);
  const widgetImage = isBaroulettaGaming ? freeSpinData.widgetImage : freeSpinData.gameImageUrl;

  const timer = userFreeSpinsStore.getFreeSpinTimerFormatted(freeSpinData.id, t);

  return (
    <div className="home-widget">
      <div
        className={classNames('circle-parent', classes.circleParent, freeSpinData.type)}
        data-testid="user-free-spins-widget-button"
        onClick={() => userFreeSpinsStore.openFreeSpinDialogById(freeSpinData.id, 'widget')}
      >
        <FRBWidget
          betAmount={Number(freeSpinData.bet)}
          className="home-widget-child"
          coinType={freeSpinData.coinType || 'GC'}
          dataTestId={`free-spin-widget-${freeSpinData.provider}-${freeSpinData.bonusCode}`}
          freeSpinType={freeSpinData.type}
          gameImage={widgetImage}
          maxPrize={freeSpinData.maxPrize}
          provider={freeSpinData.provider}
          rounds={Number(freeSpinData.rounds) - Number(freeSpinData.progress)}
          type="freeSpins"
        />
        {timer && (
          <div className={classes.timer} data-testid={`free-spin-timer-${freeSpinData.provider}-${freeSpinData.id}`}>
            {timer}
          </div>
        )}
      </div>
    </div>
  );
});
